import React, { useEffect, useState } from 'react';
import { useWindowSize } from '@react-hook/window-size';
import Button from '@sabre/spark-react-core/button';
import Checkbox from '@sabre/spark-react-core/checkbox';
import Icon from '@sabre/spark-react-core/icon';
import TextInput from '@sabre/spark-react-core/text-input';
import Tooltip from '@sabre/spark-react-core/tooltip';
import { func, array, bool, any, number, string, object } from 'prop-types';
import { Popover } from 'react-tiny-popover';
import { Column, Table } from 'react-virtualized';
import 'react-virtualized/styles.css';
import { sortTableHeaders } from '../../../utils/common-util.js';
import {
   CRITERIA_HEADER_DETAILS,
   INSERT_FIELD_MAX_VALUES,
   USER_ACCOUNT_CODE,
   CONTEXT_MENU_OPTIONS_FARES,
   CONTEXT_MENU_OPTIONS_DISTRIBUTION,
   ROW_EDIT_ENABLED_DEFAULT_FARES_COLUMN,
   ROW_EDIT_ENABLED_DISTRIBUTION_SCREEN_COLUMN,
   CAMEL_CASE_ACTION,
   CAMEL_CASE_TYPES,
   SCREEN_NAMES,
   USER_ACTION_CODE_FARES_SCREEN,
   FARE_STATUS,
   SYSTEM_KEY,
   DISTRIBUTION_STATUS,
} from '../../../utils/constants.js';

const TableView = ({
   rowData,
   reference,
   isLeftSideLayoutOpen,
   isScroll,
   isMultiFilter,
   handleScrolling,
   getSelectedIndex,
   selectedRowDetails,
   headerData,
   handleSorting,
   handleFilterChange,
   handleFilterUniqueItems,
   handleClearEvent,
   totalItem,
   fullData,
   isStopAPI,
   hostCarrier,
   title,
   handleInsertRow,
   isFetchDataCompleted,
   handleEditDataUpdated,
   showWarning,
   copyRow,
   selectedScreen,
   isLogText,
   handleLogInputTextChange,
   handleLogNotesSendClick,
   removeCellData,
   distributionListApproveAction,
   updateDoubleClickedRows,
   isDisabled,
}) => {
   const [selectedRecordConfig, setSelectedRecordConfig] = useState({
      selectedRowIndex: [0],
      selectedCellIndex: 0,
      selectedCellTableType: isScroll
         ? CAMEL_CASE_TYPES.SECONDARY_TABLE
         : CAMEL_CASE_TYPES.PRIMARY_TABLE,
      currentRow: 1,
   });
   const [keyConfig, setKeyConfig] = useState({
      keyCode: 0,
      ctrl: false,
   });
   const [rightClickRow, setRightClickRow] = useState({
      selectRow: -1,
      selectedCell: -1,
   });
   const [titleConfig, setTitleConfig] = useState([]);
   const [tableHeaderData, setTableHeaderData] = useState(headerData);
   const [selectedConfig, setSelectedConfig] = useState({
      selectedColumnKey: '',
   });
   const [popUpOpenCloseConfig, setPopUpOpenCloseConfig] = useState({
      rowDetails: {},
   });
   const [tableWidth, setTableWidth] = useState(0);
   const [height] = useWindowSize();
   const [tableHeight, setTableHeight] = useState(height);
   const [logTableWidth, setLogTableWidth] = useState(0);
   useEffect(() => {
      const divElement = document.querySelector(
         `.${
            selectedScreen === 'Fares' ? 'parent' : 'distribution'
         }-table-component-height`
      );
      const elemHeight = divElement.offsetHeight;
      setTableHeight(elemHeight);
   }, [height]);
   const otherKeyDownEvent = (event) => {
      if (
         (event.keyCode === 88 ||
            event.keyCode === 90 ||
            event.keyCode === 83 ||
            event.keyCode === 71 ||
            event.keyCode === 82 ||
            event.keyCode === 68) &&
         event.ctrlKey
      ) {
         event.preventDefault();
         setKeyConfig({
            keyCode: event.keyCode,
            ctrl: event.ctrlKey,
         });
      }
   };
   const undoAction = (type) => {
      const undoList = [];
      rowData.filter((list, index) => {
         if (list.uac) undoList.push(index);
      });
      if (undoList.length > 0) copyRow(undoList, undefined, type);
   };
   useEffect(() => {
      getSelectedIndex({
         selectedRowIndex: [0],
         selectedCellIndex: 0,
         selectedCellTableType: CAMEL_CASE_TYPES.PRIMARY_TABLE,
         currentRow: 0,
      });
      document.addEventListener('keydown', otherKeyDownEvent, true);
      return () => {
         document.removeEventListener('keydown', otherKeyDownEvent, true);
      };
   }, []);

   useEffect(() => {
      if (
         keyConfig.keyCode === 88 &&
         keyConfig.ctrl &&
         selectedScreen === SCREEN_NAMES.FARES
      ) {
         templateRow(selectedRecordConfig.currentRow, CAMEL_CASE_ACTION.CANCEL);
      } else if (keyConfig.keyCode === 90 && keyConfig.ctrl) {
         selectedScreen === SCREEN_NAMES.FARES
            ? undoAction && undoAction(CAMEL_CASE_ACTION.UNDO)
            : distributionListApproveAction &&
              distributionListApproveAction('Undo Selected');
      } else if (
         keyConfig.keyCode === 83 &&
         keyConfig.ctrl &&
         ((selectedScreen === SCREEN_NAMES.REFERENCE && !isScroll) ||
            selectedScreen === SCREEN_NAMES.FARES)
      ) {
         if (
            rowData.filter(
               (item) =>
                  (item.uac === USER_ACTION_CODE_FARES_SCREEN.NEW ||
                     item.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) &&
                  item.isInsert
            ).length > 0
         )
            distributionListApproveAction(CAMEL_CASE_TYPES.SAVE);
         else showWarning('Temporary fares record not available.');
      } else if (
         keyConfig.keyCode === 71 &&
         keyConfig.ctrl &&
         distributionListApproveAction
      ) {
         distributionListApproveAction('New Distribution Group');
      } else if (
         keyConfig.keyCode === 68 &&
         keyConfig.ctrl &&
         distributionListApproveAction
      ) {
         distributionListApproveAction(CAMEL_CASE_TYPES.DELETE);
      } else if (
         keyConfig.keyCode === 82 &&
         keyConfig.ctrl &&
         distributionListApproveAction
      ) {
         distributionListApproveAction('Show Fares');
      }
   }, [keyConfig]);

   const handleColumnClick = (data) => {
      setSelectedConfig({
         ...selectedConfig,
         selectedColumnKey: data.dataKey,
      });
   };
   const handleRowStyle = (row) => {
      if (
         selectedRecordConfig.selectedRowIndex &&
         selectedRecordConfig.selectedRowIndex.length > 0 &&
         selectedRecordConfig.selectedRowIndex.includes(row.index)
      )
         return {
            backgroundColor:
               row.index >= 0 && rowData[row.index].cxr !== hostCarrier
                  ? '#3399cc'
                  : 'gray',
            color: '#fff',
            cursor: 'pointer',
         };
      else {
         return {
            backgroundColor:
               row.index !== -1 &&
               (rowData[row.index].cxr !== hostCarrier &&
               selectedScreen === SCREEN_NAMES.FARES
                  ? '#bceaf8'
                  : 'white'),
            color:
               row.index !== -1 &&
               (rowData[row.index].cxr !== hostCarrier ? 'black' : 'black'),
            cursor: 'pointer',
         };
      }
   };
   const handleContextmenu = (event) => {
      event.preventDefault();
   };
   useEffect(() => {
      if (selectedRowDetails) {
         setSelectedRecordConfig({
            ...selectedRecordConfig,
            selectedRowIndex: [...new Set(selectedRowDetails.selectedRowIndex)],
            selectedCellTableType: selectedRowDetails.selectedCellTableType,
            selectedCellIndex:
               selectedRowDetails.selectedCellTableType ===
                  CAMEL_CASE_TYPES.SECONDARY_TABLE && isScroll
                  ? selectedRowDetails.selectedCellIndex
                  : selectedRowDetails.selectedCellTableType ===
                       CAMEL_CASE_TYPES.PRIMARY_TABLE && !isScroll
                  ? selectedRowDetails.selectedCellIndex
                  : -11,
            currentRow: selectedRowDetails.currentRow,
         });
         setRightClickRow({
            selectRow: -1,
            selectedCell: -1,
         });
         if (
            (selectedScreen === SCREEN_NAMES.REFERENCE && !isScroll) ||
            selectedScreen === SCREEN_NAMES.FARES
         )
            document.addEventListener('contextmenu', handleContextmenu, true);

         return () => {
            document.removeEventListener(
               'contextmenu',
               handleContextmenu,
               true
            );
         };
      }
   }, [selectedRowDetails]);

   const calculateWidth = (width) => {
      switch (width) {
         case 2:
            width = 35;
            break;
         case 3:
            width = 45;
            break;
         case 4:
            width = 55;
            break;
         case 5:
            width = 65;
            break;
         case 6:
            width = 75;
            break;
         case 7:
            width = 85;
            break;
         case 8:
            width = 95;
            break;
         case 9:
            width = 95;
            break;
         case 10:
            width = 105;
            break;
         case 11:
            width = 115;
            break;
         case 12:
            width = 125;
            break;
         case 13:
            width = 135;
            break;
         case 14:
            width = 145;
            break;
         case 15:
            width = 155;
            break;
         case 16:
            width = 165;
            break;
         case 17:
            width = 175;
            break;
         case 18:
            width = 185;
            break;
         case 19:
            width = 195;
            break;
         case 20:
            width = 205;
            break;
         case 21:
            width = 215;
            break;
         case 22:
            width = 225;
            break;
         case 23:
            width = 235;
            break;
         case 24:
            width = 245;
            break;
         case 25:
            width = 255;
            break;
         case 26:
            width = 265;
            break;
         case 27:
            width = 275;
            break;
         case 28:
            width = 285;
            break;
         case 29:
            width = 295;
            break;
         case 30:
            width = 305;
            break;
         case 31:
            width = 315;
            break;
         default:
            width = 275;
            break;
      }
      return width;
   };
   const bindingTableTitle = (updatedRecord) => {
      if (isScroll) {
         title.map((list) => {
            list.width = 0;
            const filterResult = updatedRecord.filter(
               (subList) =>
                  list.titleName === subList.groupName &&
                  subList.screen === selectedScreen
            );
            filterResult.map((item) => {
               return (list.width = list.width + item.width);
            });
            return list;
         });
      }
      setTitleConfig(title);
   };
   useEffect(() => {
      if (headerData.length > 0) {
         let totalWidth = 0;
         const updatedRecord = headerData.map((list) => {
            if (list.uniqueFilters) {
               const isSelectAll = list.uniqueFilters.every(
                  (subList) => subList.value === true
               );
               list.isSelectAll = isSelectAll ? true : false;
            }
            let uniqueFilter = [];
            rowData.map((newList) => {
               if (
                  (!newList[list.key] && newList[list.key] !== 0) ||
                  newList[list.key] === '|'
               )
                  uniqueFilter.push('null');
               else if (newList[list.key] || newList[list.key] === 0)
                  uniqueFilter.push(newList[list.key].toString());
            });
            let uniqueResult = [...new Set(uniqueFilter)];
            list.stringLength =
               uniqueResult.length > 0
                  ? Math.max(...uniqueResult.map((el) => el.length))
                  : 0;
            if (list.key === 'notes')
               list.stringLength = uniqueResult.length > 0 ? 10 : 0;
            const tableHeaders = sortTableHeaders(uniqueResult, list.key).map(
               (item) => {
                  return {
                     key: item,
                     value: true,
                  };
               }
            );
            if (
               list.key !== 'yq' &&
               list.key !== 'yr' &&
               list.key !== 'amt' &&
               list.key !== 'sur' &&
               list.key !== 'tax' &&
               list.key !== 'ttl'
            )
               list.width = calculateWidth(
                  list.stringLength
                     ? list.stringLength > list.key.length
                        ? list.stringLength
                        : list.key.length
                     : list.key.length
               );
            else
               list.width = calculateWidth(
                  list.stringLength
                     ? list.stringLength < 8
                        ? 7
                        : list.stringLength
                     : list.key.length
               );
            if (
               (list.isAscending || list.isDecending) &&
               list.isShowFilterControls &&
               list.key !== 'amt' &&
               list.key !== 'fbc' &&
               list.key !== 'rec dt'
            ) {
               list.width = list.width + 33;
            }
            if (
               (list.key === 'notes' ||
                  list.key === 'timestamp' ||
                  list.key === 'cr user') &&
               isScroll
            ) {
               list.width =
                  list.key === 'notes'
                     ? document.querySelector('.distribution-log-table')
                          .offsetWidth - totalWidth
                     : calculateWidth(list.key.length);
               setLogTableWidth(totalWidth);
            }
            totalWidth = totalWidth + list.width;
            const emptyStringIndex = tableHeaders.findIndex(
               (item) => item.key === 'null'
            );
            if (emptyStringIndex !== -1) {
               tableHeaders.unshift(
                  tableHeaders.splice(emptyStringIndex, 1)[0]
               );
            }
            list.uniqueFilters = tableHeaders;
            return list;
         });
         bindingTableTitle(updatedRecord);
         setTableWidth(totalWidth);
         setTableHeaderData(updatedRecord);
      }
   }, [headerData]);

   const distributionNotAllowMessage = (distributionNumber) => {
      showWarning(
         `Distribution Group Number ${distributionNumber} is distributed. Update not allowed.`
      );
   };
   const handleCellClick = (event, item) => {
      if (event.detail === 2) return;
      const isRowAvailable = selectedRecordConfig.selectedRowIndex.includes(
         item.rowIndex
      );
      if (isRowAvailable && event.ctrlKey) {
         const updatedArray = selectedRecordConfig.selectedRowIndex.filter(
            (list) => list !== item.rowIndex
         );
         const updatedRow = {
            selectedRowIndex: updatedArray,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: updatedArray.length > 0 ? updatedArray[0] : -1,
         };
         setSelectedRecordConfig(updatedRow);
         if (!isLogText) getSelectedIndex(updatedRow);
         return;
      } else if (
         isRowAvailable &&
         !event.ctrlKey &&
         item.rowIndex === selectedRecordConfig.currentRow &&
         selectedRecordConfig.selectedCellIndex === item.columnIndex
      ) {
         const updatedRow = {
            selectedRowIndex: [],
            selectedCellIndex: -1,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: -1,
         };
         setRightClickRow({
            selectRow: -1,
            selectedCell: -1,
         });
         setSelectedRecordConfig(updatedRow);
         if (!isLogText) getSelectedIndex(updatedRow);

         return;
      }
      if (!event.shiftKey || event.ctrlKey) {
         const selectedRows = event.ctrlKey
            ? selectedRecordConfig.selectedRowIndex &&
              selectedRecordConfig.selectedRowIndex.length > 0
               ? [...selectedRecordConfig.selectedRowIndex]
               : []
            : [];
         selectedRows.push(item.rowIndex);
         const updatedRow = {
            selectedRowIndex: selectedRows,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: item.rowIndex,
         };
         setSelectedRecordConfig(updatedRow);
         setRightClickRow({
            selectRow: -1,
            selectedCell: -1,
         });
         if (
            selectedScreen === SCREEN_NAMES.FARES ||
            (selectedScreen === SCREEN_NAMES.REFERENCE &&
               !isScroll &&
               !isLogText)
         )
            getSelectedIndex(updatedRow);
      } else {
         const updatedArray = [...selectedRecordConfig.selectedRowIndex];
         const startRow =
            selectedRecordConfig.selectedRowIndex[0] > item.rowIndex
               ? item.rowIndex
               : selectedRecordConfig.selectedRowIndex[0];
         const endRow =
            selectedRecordConfig.selectedRowIndex[0] > item.rowIndex
               ? selectedRecordConfig.selectedRowIndex[0]
               : item.rowIndex;
         for (var row = startRow; row <= endRow; row++) {
            if (!updatedArray.includes(row)) updatedArray.push(row);
         }
         const updatedRow = {
            selectedRowIndex: updatedArray,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: item.rowIndex,
         };
         setSelectedRecordConfig(updatedRow);
         if (!isLogText) getSelectedIndex(updatedRow);
      }
   };
   const handleDoubleClick = (event, item) => {
      const selectedRows =
         event.ctrlKey || event.shiftKey
            ? selectedRecordConfig.selectedRowIndex &&
              selectedRecordConfig.selectedRowIndex.length > 0
               ? [...selectedRecordConfig.selectedRowIndex]
               : []
            : [];
      selectedRows.push(item.rowIndex);
      const updatedRow = {
         selectedRowIndex: selectedRows,
         selectedCellIndex: item.columnIndex,
         selectedCellTableType: isScroll
            ? CAMEL_CASE_TYPES.SECONDARY_TABLE
            : CAMEL_CASE_TYPES.PRIMARY_TABLE,
         currentRow: item.rowIndex,
      };
      setSelectedRecordConfig(updatedRow);
      setRightClickRow({
         selectRow: -1,
         selectedCell: -1,
      });
      if (!isLogText) getSelectedIndex(updatedRow);
      if (
         (ROW_EDIT_ENABLED_DEFAULT_FARES_COLUMN.includes(item.dataKey) &&
            (!item.rowData.uac ||
               item.rowData.uac === USER_ACTION_CODE_FARES_SCREEN.ERROR)) ||
         ROW_EDIT_ENABLED_DISTRIBUTION_SCREEN_COLUMN.includes(item.dataKey)
      )
         updateDoubleClickedRows(updatedRow, item, true);
   };
   const insertRow = (item) => {
      handleInsertRow(item.rowIndex);
      const updatedRow = {
         selectedRowIndex: [item.rowIndex],
         selectedCellIndex: item.columnIndex,
         selectedCellTableType: isScroll
            ? CAMEL_CASE_TYPES.SECONDARY_TABLE
            : CAMEL_CASE_TYPES.PRIMARY_TABLE,
         currentRow: item.rowIndex,
      };
      setRightClickRow({
         selectRow: -1,
         selectedCell: -1,
      });
      setSelectedRecordConfig(updatedRow);
      getSelectedIndex(updatedRow);
   };
   const handleKeyDown = (event, item) => {
      if (
         (item.rowIndex === rowData.length - 1 &&
            event.code === SYSTEM_KEY.ARROW_DOWN) ||
         (item.rowIndex === 0 && event.code === SYSTEM_KEY.ARROW_UP)
      )
         return;
      if (
         ((event.key === SYSTEM_KEY.ARROW_UP && event.keyCode === 38) ||
            (event.key === SYSTEM_KEY.ARROW_DOWN && event.keyCode === 40)) &&
         !event.shiftKey &&
         !event.ctrlKey
      ) {
         const selectedRows = [];
         selectedRows.push(
            event.key === SYSTEM_KEY.ARROW_UP && event.keyCode === 38
               ? item.rowIndex > 0 && item.rowIndex - 1
               : item.rowIndex + 1
         );
         const updatedRow = {
            selectedRowIndex: selectedRows,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: selectedRows[selectedRows.length - 1],
         };
         const newRow = `row-details-${
            event.key === SYSTEM_KEY.ARROW_UP && event.keyCode === 38
               ? item.rowIndex > 0 && item.rowIndex - 1
               : item.rowIndex + 1
         }-${item.columnIndex}`;
         const selectedCell = document.getElementsByClassName(newRow);
         if (selectedCell.length > 0) {
            let selectedTable = 0;
            if (selectedCell.length === 1) selectedTable = 0;
            else selectedTable = isScroll ? 1 : 0;
            selectedCell[selectedTable].focus();
         }
         setSelectedRecordConfig(updatedRow);
         if (!isLogText) getSelectedIndex(updatedRow);
         document.getSelection().removeAllRanges();
      } else if (
         (event.key === SYSTEM_KEY.ARROW_UP &&
            event.keyCode === 38 &&
            item.rowIndex !== 0) ||
         (event.key === SYSTEM_KEY.ARROW_DOWN &&
            event.keyCode === 40 &&
            event.shiftKey)
      ) {
         let selectedRows =
            selectedRecordConfig.selectedRowIndex &&
            selectedRecordConfig.selectedRowIndex.length > 0
               ? [...selectedRecordConfig.selectedRowIndex]
               : [];
         var isAscending = selectedRows
            .slice(1)
            .every((e, i) => e > selectedRows[i]);
         if (selectedRows && selectedRows.length > 0) {
            if (
               selectedRows.includes(
                  event.key === SYSTEM_KEY.ARROW_UP
                     ? selectedRows.length > 1 && isAscending
                        ? item.rowIndex
                        : item.rowIndex - 1
                     : selectedRows.length >= 1
                     ? item.rowIndex + 1
                     : item.rowIndex
               )
            ) {
               const index = selectedRows.indexOf(
                  event.key === SYSTEM_KEY.ARROW_UP
                     ? selectedRows.length > 1 && isAscending
                        ? item.rowIndex
                        : item.rowIndex - 1
                     : item.rowIndex
               );
               selectedRows.splice(index, 1);
            } else
               selectedRows.push(
                  event.key === SYSTEM_KEY.ARROW_UP
                     ? item.rowIndex - 1
                     : item.rowIndex + 1
               );
         }
         const updatedRow = {
            selectedRowIndex: selectedRows,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll
               ? CAMEL_CASE_TYPES.SECONDARY_TABLE
               : CAMEL_CASE_TYPES.PRIMARY_TABLE,
            currentRow: selectedRows[selectedRows.length - 1],
         };
         const newRow = `row-details-${
            event.key === SYSTEM_KEY.ARROW_UP
               ? item.rowIndex > 0 && item.rowIndex - 1
               : item.rowIndex + 1
         }-${item.columnIndex}`;
         const selectedCell = document.getElementsByClassName(newRow);
         if (selectedCell.length > 0) {
            let selectedTable = 0;
            if (selectedCell.length === 1) selectedTable = 0;
            else selectedTable = isScroll ? 1 : 0;
            selectedCell[selectedTable].focus();
         }
         setSelectedRecordConfig(updatedRow);
         if (!isLogText) getSelectedIndex(updatedRow);
         document.getSelection().removeAllRanges();
      } else if (event.ctrlKey && event.keyCode === 73) {
         insertRow(item);
      } else if (
         event.ctrlKey &&
         event.keyCode === 88 &&
         selectedScreen === SCREEN_NAMES.FARES
      ) {
         templateRow(item.rowIndex, CAMEL_CASE_ACTION.CANCEL);
      } else if (
         event.keyCode === 8 &&
         event.key === SYSTEM_KEY.BACK_SPACE &&
         item.rowData.uac &&
         item.rowData.isSave
      ) {
         const data = {
            key: item.dataKey,
            row: item.rowIndex,
            table: selectedRecordConfig.selectedCellTableType,
         };
         removeCellData(data);
      } else if (event.ctrlKey && event.keyCode === 66) {
         if (item.rowData.status === DISTRIBUTION_STATUS.DISTRIBUTED) {
            distributionNotAllowMessage(item.rowData.dg);
         } else
            distributionListApproveAction(CAMEL_CASE_TYPES.DISTRIBUTE_APPROVE);
      } else if (event.ctrlKey && event.keyCode === 81) {
         distributionListApproveAction('Remove Selected');
      } else if (event.ctrlKey && event.keyCode === 67) {
         distributionListApproveAction(CAMEL_CASE_TYPES.COPY);
      }
   };
   const handleDragStart = (event, item, type) => {
      const selectedRows =
         type === 'end'
            ? selectedRecordConfig.selectedRowIndex &&
              selectedRecordConfig.selectedRowIndex.length > 0
               ? [...selectedRecordConfig.selectedRowIndex]
               : []
            : [];
      selectedRows.push(item.rowIndex);
      const updatedRow = {
         selectedRowIndex: selectedRows,
         selectedCellIndex: item.columnIndex,
         selectedCellTableType: isScroll
            ? CAMEL_CASE_TYPES.SECONDARY_TABLE
            : CAMEL_CASE_TYPES.PRIMARY_TABLE,
         currentRow: selectedRows[selectedRows.length - 1],
      };
      setSelectedRecordConfig(updatedRow);
      if (!isLogText) getSelectedIndex(updatedRow);
      const newRow = `row-details-${item.rowIndex}-${item.columnIndex}`;
      const selectedCell = document.getElementsByClassName(newRow);
      if (selectedCell.length > 0) {
         let selectedTable = 0;
         if (selectedCell.length === 1) selectedTable = 0;
         else selectedTable = isScroll ? 1 : 0;
         selectedCell[selectedTable].focus();
      }
   };
   const handleDragEnd = (event, item) => {
      event.shiftKey = true;
      handleCellClick(event, item, 'end');
   };
   const templateRow = (index, type, item, isScroll) => {
      setRightClickRow({
         selectRow: -1,
         selectedCell: -1,
      });
      const updatedRow = {
         selectedRowIndex: [],
         selectedCellIndex: -1,
         selectedCellTableType: isScroll
            ? CAMEL_CASE_TYPES.SECONDARY_TABLE
            : CAMEL_CASE_TYPES.PRIMARY_TABLE,
         currentRow: -1,
      };
      setSelectedRecordConfig(updatedRow);
      getSelectedIndex(updatedRow);
      copyRow(
         selectedRecordConfig.selectedRowIndex,
         index,
         type,
         item,
         isScroll
      );
   };
   const handleInsertTableRow = (event, item, type) => {
      if (type === 'Insert') insertRow(item);
      else if (type === 'Template' || type === CAMEL_CASE_ACTION.CANCEL) {
         if (type === 'Template') {
            const selectedDetails = [];
            selectedRecordConfig.selectedRowIndex.map((subItem, index) => {
               if (index === 0)
                  selectedDetails.push(selectedRecordConfig.currentRow + 1);
               else
                  selectedDetails.push(
                     selectedRecordConfig.currentRow + index + 1
                  );
            });
         }
         updateDoubleClickedRows(selectedRecordConfig, item, false);
         templateRow(item.rowIndex, type);
      } else if (type === CAMEL_CASE_ACTION.UNDO) {
         undoAction(type);
      } else if (
         [
            'Distribute/Approve',
            'New Distribution Group',
            'Delete',
            'Remove Selected',
            'Copy',
            'Show Fares',
            'Undo Selected',
         ].includes(type)
      ) {
         if (
            type === CAMEL_CASE_TYPES.DISTRIBUTE_APPROVE &&
            item.rowData.status === DISTRIBUTION_STATUS.DISTRIBUTED
         ) {
            distributionNotAllowMessage(item.rowData.dg);
            setRightClickRow({
               selectRow: -1,
               selectedCell: -1,
            });
         } else distributionListApproveAction(type);
      } else if (type === CAMEL_CASE_TYPES.SAVE) {
         if (
            rowData.filter(
               (item) =>
                  (item.uac === USER_ACTION_CODE_FARES_SCREEN.NEW ||
                     item.uac === USER_ACTION_CODE_FARES_SCREEN.UPDATE) &&
                  item.isInsert
            ).length > 0
         )
            distributionListApproveAction(type);
         else showWarning('Temporary fares record not available.');
      }
   };
   const handleTextChange = (event, item) => {
      const pointer = event.target.selectionStart;
      const element = event.target;
      window.requestAnimationFrame(() => {
         element.selectionStart = pointer;
         element.selectionEnd = pointer;
      });
      const isValid =
         item.dataKey !== 'email' &&
         INSERT_FIELD_MAX_VALUES.find((list) => list.key === item.dataKey)
            .max >= event.target.value.length;
      if (!isValid && item.dataKey !== 'email') {
         showWarning(
            `'Please enter maximum' ${
               event.target.value.length - 1
            } 'characters in' ${item.dataKey} '-' ${
               CRITERIA_HEADER_DETAILS.filter(
                  (list) => list.KEY === item.dataKey
               )[0].VALUE
            } field.`
         );
         return;
      }
      if (item.dataKey === 'uac') {
         const isValidCode = USER_ACCOUNT_CODE.find(
            (list) => list === event.target.value.toString().toUpperCase()
         );
         if (!isValidCode && event.target.value) {
            showWarning(
               `'Please enter valid (N, X, C, U) these 'characters in' ${
                  item.dataKey
               } '-' ${
                  CRITERIA_HEADER_DETAILS.filter(
                     (list) => list.KEY === item.dataKey
                  )[0].VALUE
               } field.`
            );
            return;
         }
      }
      handleEditDataUpdated(
         event.target.value.toString().toUpperCase(),
         item,
         isScroll,
         CAMEL_CASE_ACTION.CHANGE
      );
   };
   const handleKeyPress = (event, code) => {
      if (
         (!/[0-9]/.test(event.key) && code === 'RTG') ||
         (!/^[0-9,]+$/.test(event.key) && code === 'TAR') ||
         (!/^\d*\.?\d*$/.test(event.key) &&
            (code === 'SUR' ||
               code === 'YQ' ||
               code === 'YR' ||
               code === 'TAX' ||
               code === 'AP' ||
               code === 'DC')) ||
         (!/^[A-Za-z]+$/.test(event.key) && code === 'UAC')
      )
         event.preventDefault();
   };
   const handleBlurEvent = (event, item) => {
      if (
         (item.dataKey === 'amt' ||
            item.dataKey === 'ttl' ||
            item.dataKey === 'fbc') &&
         item.rowData.uac
      )
         handleEditDataUpdated(
            item.cellData,
            item,
            isScroll,
            CAMEL_CASE_ACTION.BLUR
         );
      else if (
         (ROW_EDIT_ENABLED_DEFAULT_FARES_COLUMN.includes(item.dataKey) &&
            selectedRecordConfig.selectedRowIndex.length === 1 &&
            !item.rowData.uac) ||
         (ROW_EDIT_ENABLED_DISTRIBUTION_SCREEN_COLUMN.includes(item.dataKey) &&
            item.rowData.uac)
      ) {
         handleEditDataUpdated(
            item.cellData,
            item,
            isScroll,
            item.dataKey === 'fbc'
               ? CAMEL_CASE_ACTION.BLUR
               : CAMEL_CASE_ACTION.UPDATES
         );
      } else if (
         ROW_EDIT_ENABLED_DEFAULT_FARES_COLUMN.includes(item.dataKey) &&
         selectedRecordConfig.selectedRowIndex.length > 1 &&
         !item.rowData.uac
      ) {
         templateRow(item.rowIndex, CAMEL_CASE_TYPES.MULTIEDIT, item, isScroll);
      }
   };
   const handleFocus = (event) => event.target.select();
   const renderCell = (item) => {
      return (item.rowData.isInsert &&
         (item.dataKey === 'org' ||
            item.dataKey === 'des' ||
            item.dataKey === 'cxr' ||
            item.dataKey === 'fbc' ||
            item.dataKey === 'tar' ||
            item.dataKey === 'owrt' ||
            item.dataKey === 'cur' ||
            item.dataKey === 'amt' ||
            item.dataKey === 'ttl' ||
            item.dataKey === 'rtg' ||
            item.dataKey === 'ft' ||
            item.dataKey === 'eff dt' ||
            item.dataKey === 'disc dt')) ||
         (item.dataKey === 'uac' && item.rowData.isInsert) ||
         (item.rowData.isDoubleClick &&
            item.rowData.key === item.dataKey &&
            (item.dataKey === 'ft' ||
               item.dataKey === 'amt' ||
               item.dataKey === 'fbc' ||
               item.dataKey === 'eff dt' ||
               item.dataKey === 'disc dt' ||
               item.dataKey === 'description' ||
               item.dataKey === 'int dist dt' ||
               item.dataKey === 'ex ind' ||
               item.dataKey === 'ex ind' ||
               item.dataKey === 'rel ind' ||
               item.dataKey === 'ign err' ||
               item.dataKey === 'lfc' ||
               item.dataKey === 'tax ind' ||
               item.dataKey === 'justification' ||
               item.dataKey === 'email')) ? (
         <TextInput
            onBlur={(event) => handleBlurEvent(event, item)}
            className={`${
               selectedRecordConfig.selectedRowIndex &&
               selectedRecordConfig.selectedRowIndex.length > 0 &&
               selectedRecordConfig.selectedRowIndex.includes(item.rowIndex)
                  ? 'new-empty-row-insert-selection-bg'
                  : 'new-empty-row-insert-bg'
            } ${
               !isNaN(item.cellData) &&
               item.dataKey !== 'rule' &&
               item.dataKey !== 'ft'
                  ? 'text-align-right spark-pad-r-.5'
                  : 'text-align-left'
            }`}
            value={item?.cellData?.toString().toUpperCase()}
            onFocus={(event) => handleFocus(event)}
            autoFocus={
               item.rowData.isDoubleClick &&
               selectedRecordConfig.selectedCellIndex === item.columnIndex
                  ? true
                  : false
            }
            onKeyPress={(event) =>
               handleKeyPress(event, item.dataKey.toUpperCase())
            }
            onChange={(event) => handleTextChange(event, item)}
         />
      ) : item.cellData ? (
         item.cellData.toString()
      ) : (
         item.cellData
      );
   };
   const cellRenderer = (item) => {
      return selectedRecordConfig.currentRow === item.rowIndex &&
         rightClickRow.selectedCell === item.columnIndex ? (
         <Popover
            isOpen={
               selectedRecordConfig.currentRow === item.rowIndex &&
               rightClickRow.selectedCell === item.columnIndex
            }
            positions={['bottom']}
            containerClassName={'pop-bg-context-menu'}
            content={
               <div className=''>
                  {(selectedScreen === SCREEN_NAMES.FARES
                     ? CONTEXT_MENU_OPTIONS_FARES
                     : CONTEXT_MENU_OPTIONS_DISTRIBUTION
                  ).map((contextMenuList) => {
                     return (
                        <div
                           className='spark-bold insert-row spark-flex custom-cell'
                           onClick={(event) =>
                              handleInsertTableRow(
                                 event,
                                 item,
                                 contextMenuList.key
                              )
                           }
                        >
                           {contextMenuList.key}
                           <span className='spark-pad-l-1'>{`(${contextMenuList.shortCut})`}</span>
                        </div>
                     );
                  })}
               </div>
            }
         >
            <div
               onClick={(event) => handleCellClick(event, item)}
               onDoubleClick={(event) => handleDoubleClick(event, item)}
               onKeyUp={(event) => handleKeyDown(event, item)}
               draggable='true'
               onDragStart={(event) => handleDragStart(event, item)}
               onDragLeave={(event) => handleDragEnd(event, item)}
               tabIndex='0'
               className={` default-cell row-details-${item.rowIndex}-${
                  item.columnIndex
               } data-trim table-height spark-pad-l-.5 ${
                  !isNaN(item.cellData) &&
                  item.dataKey !== 'rule' &&
                  item.dataKey !== 'ft'
                     ? 'text-align-right spark-pad-r-.5'
                     : 'text-align-left'
               } ${
                  selectedRecordConfig.selectedRowIndex &&
                  selectedRecordConfig.selectedRowIndex.length > 0 &&
                  selectedRecordConfig.currentRow === item.rowIndex &&
                  selectedRecordConfig.selectedCellIndex === item.columnIndex
                     ? 'tr-selected-cell'
                     : 'tr-un-selected-cell'
               } ${
                  item.rowData.isInsert === true
                     ? selectedRecordConfig.selectedRowIndex &&
                       selectedRecordConfig.selectedRowIndex.length > 0 &&
                       selectedRecordConfig.selectedRowIndex.includes(
                          item.rowIndex
                       )
                        ? 'new-empty-row-insert-selection-bg spark-bold'
                        : 'new-empty-row-insert-bg spark-bold'
                     : item.rowData.isCancel === true
                     ? 'new-empty-row-cancel-bg  spark-bold'
                     : ''
               } ${
                  selectedRecordConfig.selectedRowIndex &&
                  selectedRecordConfig.selectedRowIndex.length > 0 &&
                  selectedRecordConfig.currentRow === item.rowIndex &&
                  item.rowData.isDoubleClick &&
                  !item.rowData.uac
                     ? 'update-text-bg'
                     : ''
               } ${
                  selectedScreen === SCREEN_NAMES.REFERENCE && item.rowData.uac
                     ? 'dg-row-update-bg '
                     : ''
               }`}
               title={item.cellData}
            >
               {renderCell(item)}
            </div>
         </Popover>
      ) : (
         <div
            onClick={(event) => handleCellClick(event, item)}
            onDoubleClick={(event) => handleDoubleClick(event, item)}
            onKeyUp={(event) => handleKeyDown(event, item)}
            draggable='true'
            onDragStart={(event) => handleDragStart(event, item)}
            onDragLeave={(event) => handleDragEnd(event, item)}
            tabIndex='0'
            className={` default-cell row-details-${item.rowIndex}-${
               item.columnIndex
            } data-trim table-height spark-pad-l-.5 ${
               !isNaN(item.cellData) &&
               item.dataKey !== 'rule' &&
               item.dataKey !== 'ft'
                  ? 'text-align-right spark-pad-r-.5'
                  : 'text-align-left'
            } ${
               selectedRecordConfig.selectedRowIndex &&
               selectedRecordConfig.selectedRowIndex.length > 0 &&
               selectedRecordConfig.currentRow === item.rowIndex &&
               !item.rowData.isSave &&
               !item.rowData.isReject &&
               selectedRecordConfig.selectedCellIndex === item.columnIndex
                  ? 'tr-selected-cell'
                  : (item.rowData.isSave === true ||
                       item.rowData.status === FARE_STATUS.WORKING) &&
                    selectedRecordConfig.currentRow === item.rowIndex &&
                    selectedRecordConfig.selectedCellIndex === item.columnIndex
                  ? 'new-saved-row-selection-bg tr-selected-cell'
                  : item.rowData.isSave === true ||
                    item.rowData.status === FARE_STATUS.WORKING
                  ? 'new-saved-row-selection-bg'
                  : item.rowData.isReject === true &&
                    selectedRecordConfig.currentRow === item.rowIndex &&
                    selectedRecordConfig.selectedCellIndex === item.columnIndex
                  ? 'new-rejected-row-selection-bg tr-selected-cell'
                  : item.rowData.isReject === true
                  ? 'new-rejected-row-selection-bg'
                  : item.rowData.status === FARE_STATUS.DISTRIBUTED &&
                    selectedRecordConfig.currentRow === item.rowIndex &&
                    selectedRecordConfig.selectedCellIndex === item.columnIndex
                  ? 'distribution-record-bg tr-selected-cell'
                  : item.rowData.status === FARE_STATUS.DISTRIBUTED
                  ? 'distribution-record-bg'
                  : 'tr-un-selected-cell'
            } ${
               item.rowData.isInsert === true
                  ? selectedRecordConfig.selectedRowIndex &&
                    selectedRecordConfig.selectedRowIndex.length > 0 &&
                    selectedRecordConfig.selectedRowIndex.includes(
                       item.rowIndex
                    )
                     ? 'new-empty-row-insert-selection-bg'
                     : 'new-empty-row-insert-bg spark-bold'
                  : item.rowData.isCancel === true
                  ? 'new-empty-row-cancel-bg  spark-bold'
                  : ''
            } ${
               selectedRecordConfig.selectedRowIndex &&
               selectedRecordConfig.selectedRowIndex.length > 0 &&
               selectedRecordConfig.currentRow === item.rowIndex &&
               item.rowData.isDoubleClick &&
               !item.rowData.uac
                  ? 'update-text-bg'
                  : ''
            } ${
               selectedScreen === SCREEN_NAMES.REFERENCE && item.rowData.uac
                  ? 'dg-row-update-bg '
                  : ''
            }`}
            title={item.cellData}
         >
            {renderCell(item)}
         </div>
      );
   };
   const handleShowFilter = (rowDetails) => {
      const update = tableHeaderData.map((item) => {
         if (item.key === rowDetails.key) {
            item.isFilterOpen = !item.isFilterOpen;
         }
         return item;
      });
      setTableHeaderData(update);
   };

   const handleEnableControles = (rowDetails) => {
      return selectedScreen === SCREEN_NAMES.REFERENCE && isScroll
         ? false
         : tableHeaderData.find((list) => list.key === rowDetails.dataKey)
              .uniqueFilters.length > 0
         ? true
         : false;
   };
   const handleMouseOver = (rowDetails) => {
      if (!handleEnableControles(rowDetails)) return;
      const isFilterOpen = tableHeaderData.some((item) => item.isFilterOpen);
      if ((!isStopAPI && parseInt(totalItem) > fullData.length) || isFilterOpen)
         return;
      const update = tableHeaderData.map((item) => {
         if (item.key === rowDetails.dataKey && !item.isFilterOpen) {
            if (
               item.key !== 'yq' &&
               item.key !== 'yr' &&
               item.key !== 'amt' &&
               item.key !== 'sur' &&
               item.key !== 'tax' &&
               item.key !== 'ttl'
            )
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength > item.key.length
                        ? item.stringLength
                        : item.key.length
                     : item.key.length
               );
            else
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength < 8
                        ? 7
                        : item.stringLength
                     : item.key.length
               );
            if (item.key === 'notes' && isScroll) {
               item.width =
                  document.querySelector('.distribution-log-table')
                     .offsetWidth - logTableWidth;
            }
            item.width =
               item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt'
                  ? item.width + 33
                  : item.width;
            item.isShowFilterControls = true;
         }
         return item;
      });
      bindingTableTitle(update);
      setTableHeaderData(update);
   };
   const handleMouseLeave = (rowDetails) => {
      if (!handleEnableControles(rowDetails)) return;
      const isFilterOpen = tableHeaderData.some((item) => item.isFilterOpen);
      if ((!isStopAPI && parseInt(totalItem) > fullData.length) || isFilterOpen)
         return;
      setPopUpOpenCloseConfig({
         rowDetails: rowDetails,
      });

      const update = tableHeaderData.map((item) => {
         if (item.key === rowDetails.dataKey && item.isShowFilterControls) {
            item.width =
               item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt'
                  ? !item.isFilterOpen
                     ? item.width - 30
                     : item.width
                  : item.width;
            item.isShowFilterControls = item.isFilterOpen ? true : false;
         } else if (
            item.key === rowDetails.dataKey &&
            !item.isShowFilterControls
         ) {
            item.width =
               item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt'
                  ? item.width + 30
                  : item.width;
            item.isShowFilterControls = true;
         } else {
            if (
               item.key !== 'yq' &&
               item.key !== 'yr' &&
               item.key !== 'amt' &&
               item.key !== 'sur' &&
               item.key !== 'tax' &&
               item.key !== 'ttl'
            )
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength > item.key.length
                        ? item.stringLength
                        : item.key.length
                     : item.key.length
               );
            else
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength < 8
                        ? 7
                        : item.stringLength
                     : item.key.length
               );
            if (item.key === 'notes' && isScroll) {
               item.width =
                  document.querySelector('.distribution-log-table')
                     .offsetWidth - logTableWidth;
            }
            item.isShowFilterControls = false;
         }

         return item;
      });
      bindingTableTitle(update);
      setTableHeaderData(update);
   };
   const handleOutSideClick = () => {
      if (popUpOpenCloseConfig.rowDetails) {
         const update = tableHeaderData.map((item) => {
            if (item.key === popUpOpenCloseConfig.rowDetails.dataKey) {
               item.isShowFilterControls = false;
            }
            if (
               item.key !== 'yq' &&
               item.key !== 'yr' &&
               item.key !== 'amt' &&
               item.key !== 'sur' &&
               item.key !== 'tax' &&
               item.key !== 'ttl'
            )
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength > item.key.length
                        ? item.stringLength
                        : item.key.length
                     : item.key.length
               );
            else
               item.width = calculateWidth(
                  item.stringLength
                     ? item.stringLength < 8
                        ? 7
                        : item.stringLength
                     : item.key.length
               );
            if (item.key === 'notes' && isScroll) {
               item.width =
                  document.querySelector('.distribution-log-table')
                     .offsetWidth - logTableWidth;
            }
            item.isShowFilterControls = false;
            item.isFilterOpen = false;
            return item;
         });
         bindingTableTitle(update);
         setTableHeaderData(update);
         setPopUpOpenCloseConfig({
            ...popUpOpenCloseConfig,
            rowDetails: {},
         });
      }
   };
   const handleUniqueItem = (subItem, record) => {
      const updatedRecord = tableHeaderData.map((item) => {
         if (item.key === record.key) {
            item.uniqueFilters.map((subList) => {
               if (subList.key === subItem.key) {
                  subList.value = !subList.value;
               }
               return subList;
            });
            const isSelectAll = item.uniqueFilters.every(
               (subList) => subList.value === true
            );
            item.isSelectAll = isSelectAll ? true : false;
         }
         return item;
      });
      setTableHeaderData(updatedRecord);
   };
   const handleSelectAllClick = (isSelectAll, record) => {
      const updatedRecord = tableHeaderData.map((item) => {
         if (item.key === record.key) {
            item.isSelectAll = !isSelectAll;
            item.uniqueFilters.map((subList) => {
               subList.value = !isSelectAll;
            });
         }
         return item;
      });
      setTableHeaderData(updatedRecord);
   };
   const handleRowRightClick = (event) => {
      if (
         (selectedScreen === SCREEN_NAMES.REFERENCE && !isScroll) ||
         selectedScreen === SCREEN_NAMES.FARES
      )
         setRightClickRow({
            selectRow: event.index,
            selectedCell: selectedRecordConfig.selectedCellIndex,
         });
   };
   const renderFilter = (key) => {
      const filterValue = tableHeaderData.filter((item) => item.key === key)[0];
      return (
         <div
            className={` ${
               filterValue.isShowFilterControls
                  ? 'table-display-inherit'
                  : 'table-display-none'
            } filter`}
         >
            {
               <div>
                  <Icon
                     name='arrow-triangle-up'
                     className={` ${
                        filterValue.isDefault || filterValue.isAscending
                           ? 'table-display-inherit'
                           : 'table-display-none'
                     } filter`}
                     size='md'
                     style='fill'
                     onClick={() => handleSorting(filterValue)}
                     label='Show Stored Criteria'
                  />
                  <Icon
                     name='arrow-triangle-down'
                     className={` ${
                        filterValue.isDecending
                           ? 'table-display-inherit'
                           : 'table-display-none'
                     } filter`}
                     size='md'
                     style='fill'
                     onClick={() => handleSorting(filterValue)}
                     label='Show Stored Criteria'
                  />
               </div>
            }
            <Popover
               isOpen={filterValue.isFilterOpen}
               positions={['bottom']}
               containerClassName={` ${
                  isMultiFilter ? 'pop-bg-multi' : 'pop-bg'
               }`}
               onClickOutside={() => handleOutSideClick()}
               content={
                  <div className='full-height'>
                     <TextInput
                        className='spark-pad-l-.5'
                        name={`Search ${key}`}
                        placeholder={`Search ${key}`}
                        value={filterValue?.filterValue}
                        onChange={(event, selectedValue) =>
                           handleFilterChange(
                              selectedValue,
                              filterValue,
                              rowData
                           )
                        }
                     />
                     {isMultiFilter && filterValue.uniqueFilters.length > 0 && (
                        <div>
                           {' '}
                           <div className='full-height-button'>
                              <div className='row'>
                                 <div>
                                    <Checkbox
                                       className='spark-bold spark-align-items-center'
                                       label='Select All'
                                       checked={filterValue.isSelectAll}
                                       onChange={() =>
                                          handleSelectAllClick(
                                             filterValue.isSelectAll,
                                             filterValue
                                          )
                                       }
                                    />
                                 </div>
                              </div>
                              <div
                                 className={` ${
                                    filterValue.uniqueFilters.length > 4
                                       ? 'popup-checkbox-content'
                                       : 'popup-checkbox-min-content'
                                 } table-view-auto-x-scroll`}
                              >
                                 {filterValue.uniqueFilters.map(
                                    (subItem, index) => {
                                       return (
                                          <Checkbox
                                             key={index}
                                             className='spark-bold spark-align-items-center'
                                             label={subItem.key}
                                             checked={subItem.value}
                                             onChange={() =>
                                                handleUniqueItem(
                                                   subItem,
                                                   filterValue
                                                )
                                             }
                                          />
                                       );
                                    }
                                 )}
                              </div>
                           </div>
                           <div className='row popup-up-controls'>
                              <Button
                                 className='spark-btn-group-secondary select-button-cancel popup-up-controls-ok-button'
                                 size='xs'
                                 primary='true'
                                 disabled={filterValue.uniqueFilters.every(
                                    (item) => !item.value
                                 )}
                                 onClick={() =>
                                    handleFilterUniqueItems(
                                       filterValue,
                                       isScroll,
                                       'Apply'
                                    )
                                 }
                              >
                                 Apply
                              </Button>
                              <Button
                                 className='spark-btn-group-primary'
                                 size='xs'
                                 secondary='true'
                                 onClick={() =>
                                    handleClearEvent(
                                       filterValue,
                                       headerData,
                                       isScroll,
                                       true
                                    )
                                 }
                              >
                                 Clear
                              </Button>
                           </div>
                        </div>
                     )}
                  </div>
               }
            >
               {
                  <button
                     icon={` ${
                        !filterValue.isFilterApply ? 'menu-hamburger' : 'pencil'
                     }`}
                     onClick={() => handleShowFilter(filterValue)}
                     className={`spark-btn--icon spark-icon spark-icon--fill spark-icon--md ${
                        !filterValue.isFilterApply
                           ? 'spark-icon-menu-hamburger'
                           : 'spark-icon-pencil edit-icon spark-pad-l-.5'
                     } filter-icon`}
                  />
               }
            </Popover>
         </div>
      );
   };
   const headerRenderer = (header) => {
      return (
         <div
            className='spark-flex align-center spark-pad-l.5'
            onMouseEnter={() => handleMouseOver(header)}
            onMouseLeave={() => handleMouseLeave(header)}
         >
            <Tooltip
               anchorY='top'
               anchorX='center'
               toggleEl={
                  <div className=' header-cell cell spark-pad-l-.5 header-cell-padding'>
                     {header.label}
                  </div>
               }
            >
               <div className='spark-flex'>
                  <div>
                     {
                        CRITERIA_HEADER_DETAILS.filter(
                           (item) => item.KEY === header.label
                        )[0].VALUE
                     }
                  </div>
               </div>
            </Tooltip>
            <div className='spark-flex'>{renderFilter(header.dataKey)}</div>
         </div>
      );
   };

   return (
      <div
         className={`table-view-root  ${
            isScroll && selectedScreen === SCREEN_NAMES.FARES
               ? 'table-view-auto-x-scroll'
               : selectedScreen === SCREEN_NAMES.REFERENCE
               ? 'distribution-table-view-auto-x-scroll table-view-auto-x-scroll'
               : ''
         } ${
            selectedScreen === SCREEN_NAMES.REFERENCE && !isScroll
               ? !isLeftSideLayoutOpen
                  ? 'full-table'
                  : !isScroll
                  ? isLeftSideLayoutOpen
                     ? 'partial-table'
                     : ''
                  : ''
               : ''
         } `}
      >
         <div
            className={`table-view-root ${
               isScroll && selectedScreen === SCREEN_NAMES.FARES
                  ? 'table-component table-view-auto-x-scroll'
                  : selectedScreen === SCREEN_NAMES.REFERENCE
                  ? 'table-component distribution-table-view-auto-x-scroll table-view-auto-x-scroll '
                  : ''
            } ${
               selectedScreen === SCREEN_NAMES.FARES
                  ? 'parent-table-component-height'
                  : 'distribution-table-component-height'
            }`}
         >
            <div
               className={`${
                  titleConfig.length > 1 ? 'spark-flex' : 'table-component'
               }`}
            >
               <div
                  className={`${
                     titleConfig.length > 1 ? 'spark-flex' : 'table-component'
                  }`}
               >
                  {titleConfig.map((list, index) => (
                     <div
                        key={index}
                        className={`spark-pad-l-.5 spark-bold ${
                           titleConfig.length === 1
                              ? 'table-full-width-important table-title-odd '
                              : 'table-title-odd'
                        }`}
                        style={{ width: list.width - 1 }}
                     >
                        {list.titleName}
                     </div>
                  ))}
               </div>
            </div>
            <Table
               ref={reference}
               className='table-background'
               width={tableWidth}
               height={
                  isScroll && selectedScreen === SCREEN_NAMES.FARES
                     ? tableHeight - 43.6
                     : selectedScreen === SCREEN_NAMES.REFERENCE && !isScroll
                     ? tableHeight - 23.6
                     : selectedScreen === SCREEN_NAMES.REFERENCE && isScroll
                     ? tableHeight - 73.6
                     : tableHeight - 43.5
               }
               headerHeight={25}
               onScroll={handleScrolling}
               rowHeight={20}
               headerClassName={'table-title'}
               noRowsRenderer={() => (
                  <div className='spark-flex spark-align-items-center no-record-text spark-bold'>
                     No Record Found
                  </div>
               )}
               rowStyle={handleRowStyle}
               rowCount={rowData.length}
               onColumnClick={handleColumnClick}
               onRowRightClick={handleRowRightClick}
               rowGetter={({ index }) => rowData[index]}
            >
               {tableHeaderData.map((item) => {
                  return (
                     <Column
                        key={item.key}
                        className='cell'
                        headerRenderer={headerRenderer}
                        cellRenderer={cellRenderer}
                        width={item.width}
                        label={item.key}
                        dataKey={item.key}
                     />
                  );
               })}
            </Table>
            {!isScroll && selectedScreen === SCREEN_NAMES.FARES && totalItem ? (
               <div className={'spark-bold spark-flex justify-space-between'}>
                  {selectedRecordConfig.selectedRowIndex &&
                  selectedRecordConfig.selectedRowIndex.length > 0
                     ? selectedRecordConfig.selectedRowIndex.length > 1 &&
                       selectedRecordConfig.selectedRowIndex.length
                     : 0}{' '}
                  {selectedRecordConfig.selectedRowIndex.length > 1 ? 'r' : 'R'}
                  ecord{selectedRecordConfig.selectedRowIndex.length > 1 &&
                     's'}{' '}
                  {selectedRecordConfig.selectedRowIndex.length === 1 &&
                     `${selectedRecordConfig.currentRow + 1}`}{' '}
                  selected (Total {rowData.length}){' '}
                  <div>
                     {isStopAPI ? (
                        <div>
                           <Icon
                              name='close-circle'
                              className={'spark-danger'}
                              size='md'
                              style='fill'
                              label='API stoped'
                           />
                        </div>
                     ) : (
                        !isFetchDataCompleted && (
                           <div
                              className='loader'
                              title='Data loading...'
                           ></div>
                        )
                     )}
                  </div>
               </div>
            ) : (
               ''
            )}
            {isLogText && (
               <div className='dg-log-input-text'>
                  <TextInput
                     multiLine={true}
                     onChange={(event) => handleLogInputTextChange(event)}
                     disabled={isDisabled}
                  >
                     <Icon
                        name='paper-airplane'
                        placeholder='Type a message...'
                        size='md'
                        style='fill'
                        label='distribution-group-open'
                        onClick={!isDisabled && handleLogNotesSendClick}
                     />
                  </TextInput>
                  <div className='log-text-note spark-bold'>
                     <span className='spark-danger'>
                        This Field is Not encrypted.
                     </span>
                     <span>
                        Kindly ensure that no personal data is entered herein.
                     </span>
                  </div>
               </div>
            )}
         </div>
      </div>
   );
};
TableView.propTypes = {
   rowData: array,
   reference: any,
   isScroll: bool,
   totalItem: number,
   isLeftSideLayoutOpen: bool,
   isToolTipShow: bool,
   isMultiFilter: bool,
   selectedRowDetails: object,
   selectedCellIndexValue: number,
   handleScrolling: func,
   getSelectedIndex: func,
   getSelectedCellIndex: func,
   headerData: array,
   handleSorting: func,
   handleFilterChange: func,
   handleFilterUniqueItems: func,
   handleClearEvent: func,
   fullData: array,
   isStopAPI: bool,
   hostCarrier: string,
   title: array,
   handleInsertRow: func,
   isFetchDataCompleted: bool,
   handleEditDataUpdated: func,
   showWarning: func,
   copyRow: func,
   cancelRow: func,
   selectedScreen: string,
   isLogText: bool,
   handleLogInputTextChange: func,
   handleLogNotesSendClick: func,
   removeCellData: func,
   newTemplateIds: array,
   distributionListApproveAction: func,
   updateDoubleClickedRows: func,
   isDisabled: bool,
};
export default TableView;
